var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndroidStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 155 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-11,.cls-3,.cls-4{fill:#fff;}.cls-1{fill-opacity:0;}.cls-2{fill:#a6a6a6;}.cls-3{stroke:#fff;stroke-miterlimit:10;stroke-width:0.2px;}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:url(#linear-gradient-2);}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{opacity:0.2;}.cls-10,.cls-11,.cls-9{isolation:isolate;}.cls-10{opacity:0.12;}.cls-11{opacity:0.25;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 31.8,
    y1: 183.29,
    x2: 15.02,
    y2: 166.51,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 43.83,
    y1: 172,
    x2: 19.64,
    y2: 172,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 34.83,
    y1: 169.7,
    x2: 12.07,
    y2: 146.95,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 17.3,
    y1: 191.82,
    x2: 27.46,
    y2: 181.66,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "android-store") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "artwork"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 155,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 135,
    height: 40,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140,10.8a4.2,4.2,0,0,1,4.2,4.2V45a4.2,4.2,0,0,1-4.2,4.2H15A4.2,4.2,0,0,1,10.8,45V15A4.2,4.2,0,0,1,15,10.8H140m0-.8H15a5,5,0,0,0-5,5V45a5,5,0,0,0,5,5H140a5,5,0,0,0,5-5V15a5,5,0,0,0-5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.42,20.24a2.72,2.72,0,0,1-.75,2,2.9,2.9,0,0,1-2.2.88,3,3,0,0,1-2.21-.9,3.19,3.19,0,0,1,0-4.46,3.16,3.16,0,0,1,3.44-.65,2.54,2.54,0,0,1,.94.67l-.53.53a2,2,0,0,0-1.64-.72,2.4,2.4,0,1,0,1.68,4.13,1.92,1.92,0,0,0,.5-1.22H54.47v-.72h2.91A3.75,3.75,0,0,1,57.42,20.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62,17.74H59.3v1.9h2.46v.72H59.3v1.9H62V23H58.52V17H62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.28,23h-.77V17.74H62.83V17H67v.74H65.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.94,23V17h.77v6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.13,23h-.77V17.74H71.68V17H75.8v.74H74.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.61,22.22a3.11,3.11,0,0,1-4.4,0,3.24,3.24,0,0,1,0-4.44,2.93,2.93,0,0,1,2.2-.91,3,3,0,0,1,2.2.91A3.07,3.07,0,0,1,84.49,20,3,3,0,0,1,83.61,22.22Zm-3.83-.5a2.29,2.29,0,0,0,3.26,0,2.54,2.54,0,0,0,0-3.44,2.29,2.29,0,0,0-3.26,0,2.54,2.54,0,0,0,0,3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.58,23V17h.93l2.92,4.67h0l0-1.16V17h.77v6h-.8l-3.05-4.89h0l0,1.15V23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M78.14,31.75A4.26,4.26,0,1,0,82.41,36,4.19,4.19,0,0,0,78.14,31.75Zm0,6.83A2.58,2.58,0,1,1,80.54,36,2.46,2.46,0,0,1,78.14,38.58Zm-9.32-6.83A4.26,4.26,0,1,0,73.09,36,4.19,4.19,0,0,0,68.82,31.75Zm0,6.83A2.58,2.58,0,1,1,71.22,36,2.46,2.46,0,0,1,68.82,38.58ZM57.74,33.06v1.8h4.32a3.77,3.77,0,0,1-1,2.27,4.42,4.42,0,0,1-3.34,1.32,4.8,4.8,0,0,1,0-9.6A4.64,4.64,0,0,1,61,30.14l1.27-1.27a6.3,6.3,0,0,0-4.53-1.82,6.61,6.61,0,1,0,0,13.21,6.07,6.07,0,0,0,4.61-1.85,6,6,0,0,0,1.56-4.23,6.27,6.27,0,0,0-.09-1.12Zm45.31,1.4a4,4,0,0,0-3.64-2.71,4,4,0,0,0-4,4.25,4.23,4.23,0,0,0,7.76,2.37l-1.45-1a2.41,2.41,0,0,1-2.09,1.17,2.15,2.15,0,0,1-2.06-1.29l5.69-2.35Zm-5.8,1.42a2.34,2.34,0,0,1,2.23-2.49,1.64,1.64,0,0,1,1.57.91ZM92.63,40H94.5V27.5H92.63Zm-3.06-7.3H89.5a2.94,2.94,0,0,0-2.24-1,4.26,4.26,0,0,0,0,8.51,2.88,2.88,0,0,0,2.24-1h.07v.61c0,1.63-.87,2.5-2.27,2.5a2.36,2.36,0,0,1-2.15-1.51l-1.62.67a4,4,0,0,0,3.77,2.52c2.19,0,4-1.29,4-4.43V32H89.57Zm-2.15,5.88a2.58,2.58,0,0,1,0-5.15A2.39,2.39,0,0,1,89.7,36,2.38,2.38,0,0,1,87.42,38.58ZM111.81,27.5h-4.48V40h1.87V35.26h2.61a3.89,3.89,0,1,0,0-7.76Zm0,6H109.2V29.24h2.65a2.14,2.14,0,1,1,0,4.28Zm11.54-1.79a3.49,3.49,0,0,0-3.33,1.91l1.65.69a1.78,1.78,0,0,1,1.71-.91,1.8,1.8,0,0,1,2,1.61v.12a4.18,4.18,0,0,0-1.95-.48c-1.78,0-3.6,1-3.6,2.82a2.89,2.89,0,0,0,3.11,2.75A2.65,2.65,0,0,0,125.32,39h.06v1h1.8V35.19C127.18,33,125.52,31.73,123.39,31.73Zm-.23,6.85c-.61,0-1.46-.31-1.46-1.06,0-1,1.06-1.34,2-1.34a3.32,3.32,0,0,1,1.7.42A2.26,2.26,0,0,1,123.16,38.58ZM133.74,32l-2.14,5.42h-.06L129.32,32h-2l3.33,7.58-1.9,4.21h1.95L135.82,32Zm-16.8,8h1.86V27.5h-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M20.44,17.54a2,2,0,0,0-.47,1.4V41.06a1.94,1.94,0,0,0,.47,1.4l.07.08L32.9,30.15v-.3L20.51,17.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M37,34.28,32.9,30.15v-.3L37,25.72l.09.06L42,28.56c1.4.79,1.4,2.09,0,2.89l-4.89,2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M37.12,34.22,32.9,30,20.44,42.46a1.62,1.62,0,0,0,2.07.07l14.61-8.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M37.12,25.78l-14.61-8.3a1.61,1.61,0,0,0-2.07.06L32.9,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37,34.13,22.51,42.38a1.66,1.66,0,0,1-2,0h0l-.07.07h0l.07.08h0a1.66,1.66,0,0,0,2,0l14.61-8.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M20.44,42.32A2,2,0,0,1,20,40.91v.15a1.94,1.94,0,0,0,.47,1.4l.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M42,31.3l-5,2.83.09.09L42,31.44A1.75,1.75,0,0,0,43.06,30h0A1.86,1.86,0,0,1,42,31.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M22.51,17.62,42,28.7A1.86,1.86,0,0,1,43.06,30h0A1.75,1.75,0,0,0,42,28.56L22.51,17.48c-1.39-.8-2.54-.14-2.54,1.46v.15C20,17.49,21.12,16.83,22.51,17.62Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidStore);
export default __webpack_public_path__ + "static/media/android-store.bd76ed1eb6793a7897bb7ff468a82bc8.svg";
export { ForwardRef as ReactComponent };